"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldOfferType = OfferFieldOfferType;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const config_1 = require("@src/config");
const offer_1 = require("@src/types/offer");
const RadioGroupBox_1 = require("@src/components/elements/RadioGroupBox");
const get_offer_type_icon_1 = require("@src/helpers/get-offer-type-icon");
function OfferFieldOfferType() {
    const intl = (0, react_intl_1.useIntl)();
    const config = (0, config_1.getConfig)(intl.locale);
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
            id: 'admin.offer_form.choose_position_type',
        }), name: offer_1.EOfferBasicInfoFormField.offerTypeId, rules: [
            {
                required: true,
                message: intl.formatMessage({
                    id: 'admin.offer_validation.please_select_position_type',
                }),
            },
        ], children: (0, jsx_runtime_1.jsx)(RadioGroupBox_1.RadioGroupBox, { size: "large", boxes: config.offerTypes.map(ot => ({
                value: ot.id,
                label: ot.name,
                icon: (0, get_offer_type_icon_1.getOfferTypeTagIcon)(ot.id),
            })) }) }));
}
